import React from 'react';
import { Link } from 'react-router-dom';
import styles from "../css/MainPage.module.css";

const GettingStarted = () => {
  return (
    <div className={styles.mainPageBody}>
      <div className={styles.mainPageContainer}>
        {/* Title Section */}
        <div className={styles.mainPageHeaderContainer}>
          <h1 className={styles.mainPageHeader}>Welcome to Tech Services Market</h1>
        

        {/* Text Section */}
          <p>
            Tech Services Market was created to address the challenges recent graduates face when trying to enter the tech industry. 
            With a rapidly growing number of new software developers entering the job market, it has become increasingly difficult 
            for graduates to find opportunities that provide the hands-on experience needed to meet industry standards. 
            Our platform is designed to bridge the gap between academic knowledge and practical skills by connecting graduates 
            with real-world projects and opportunities. By using TechServicesMarket, graduates can gain relevant experience, 
            build their portfolios, and enhance their employability in the competitive job market.
          </p>
        </div>

        {/* Buttons Section */}
        <div className={styles.mainPageButtonContainer}>
          <Link to="/login" className={styles.mainPageButton}>Go to Login</Link>
          <Link to="/register" className={styles.mainPageButton}>Go to Registration</Link>
        </div>

        {/* Additional Links */}
        <div className={styles.additionalLinks}>
          <p>Are you an organization/company? <Link to="/recruiter/login" className={styles.registerLink}>Click here to Login and Register</Link></p>
          <p>Schools are open to <Link to="/university/login" className={styles.registerLink}>Login and Register here</Link></p>
        </div>
      </div>
    </div>
  );
};


export default GettingStarted;


